import createSelector from 'selectorator';
import { values } from 'underscore';

// org related
const getOrgTextFilter = state => state.internalTooling.orgTextFilter;
const getFreeFilterToggle = state => state.internalTooling.freeFilterEnabled;
const getPremiumFilterToggle = state => state.internalTooling.premiumFilterEnabled;
const getPremiumSeatFilterToggle = state => state.internalTooling.premiumSeatFilterEnabled;
const getPremiumSeat2FilterToggle = state => state.internalTooling.premiumSeat2FilterEnabled;
const getPremiumComplianceFilterToggle = state => state.internalTooling.premiumComplianceFilterEnabled;
const getPremiumCompSecFilterToggle = state => state.internalTooling.premiumCompSecFilterEnabled;
const getContributorCountFilterToggle = state => state.internalTooling.contributorCountFilterEnabled;
const getCustomBillingFilterToggle = state => state.internalTooling.customBillingFilterEnabled;
const getContributorCountRange = state => state.internalTooling.contributorCountRange;
const getAndOrToggle = state => state.internalTooling.andOrToggle;
const getFilteredOrgs = state => values(state.internalTooling.orgs.entities);
const getOrgLoadingStatus = state => state.internalTooling.orgs.fetchMany.status;
const getSelectedOrg = state => state.internalTooling.orgs.entities[state.internalTooling.orgs.selectedOrg];
const getProjectCountFilterToggle = state => state.internalTooling.projectCountFilterEnabled;
const getProjectCountRange = state => state.internalTooling.projectCountRange;
const getDeleteOrgStatus = state => state.internalTooling.orgs.delete.status;

const getOrgRequestParams = createSelector([
  getAndOrToggle,
  getFreeFilterToggle,
  getPremiumFilterToggle,
  getPremiumSeatFilterToggle,
  getPremiumSeat2FilterToggle,
  getPremiumComplianceFilterToggle,
  getPremiumCompSecFilterToggle,
  getCustomBillingFilterToggle,
  getOrgTextFilter,
  getContributorCountFilterToggle,
  getContributorCountRange,
  getProjectCountFilterToggle,
  getProjectCountRange,
], (useAnd, isFree, isPremium, isPremiumSeat, isPremiumSeat2, isPremiumComplianceSeat, isPremiumCompSecSeat, isCustomBilling, title, contributorCountEnabled, contributorCountRange, projectCountEnabled, projectCountRange) => {
  return {
    useAnd,
    isFree,
    isPremium,
    isPremiumSeat,
    isPremiumSeat2,
    isPremiumComplianceSeat,
    isPremiumCompSecSeat,
    isCustomBilling,
    title,
    contributorCount: {
      ...contributorCountRange,
      enabled: contributorCountEnabled,
    },
    projectCount: {
      ...projectCountRange,
      enabled: projectCountEnabled,
    },
  };
});

export default {
  getOrgTextFilter,
  getFreeFilterToggle,
  getPremiumFilterToggle,
  getPremiumSeatFilterToggle,
  getPremiumSeat2FilterToggle,
  getPremiumComplianceFilterToggle,
  getPremiumCompSecFilterToggle,
  getContributorCountFilterToggle,
  getCustomBillingFilterToggle,
  getContributorCountRange,
  getAndOrToggle,
  getOrgLoadingStatus,
  getFilteredOrgs,
  getSelectedOrg,
  getProjectCountFilterToggle,
  getProjectCountRange,
  getOrgRequestParams,
  getDeleteOrgStatus,
};
